export * from "./lightingVolume.pure";

import "core/ShadersWGSL/lightingVolume.compute";
